<template>
	<div class="content">
		<banner></banner>
		<div class="home1">
			<profile></profile>
			<highlights></highlights>
		</div>
		<div class="home2">
			<news></news>
			<live></live>
		</div>
		<div class="home3">
			<news_release></news_release>
			<forums></forums>
			<div id="home-display" style="position: relative; top: -1rem"></div>
			<display :list="list"></display>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import display from './components/display';
	import news from './components/news';
	import banner from './components/banner';
	import profile from './components/profile';
	import highlights from './components/highlights';
	import live from './components/live';
	import news_release from './components/news_release';
	import forums from './components/forums';
	export default {
		name: 'index',
		data() {
			return {
				enterBuild: false,
				flagtop: false,
				swiperindex: 0,
				showpage: false,
				day: "",
				hour: "", //倒计时  小时
				minute: "", // 倒计时 分钟
				seconds: "", //倒计时 秒
				interval: "",
				countdownTime: 0,
				arrs: [],
				hovers: true,
				currents: 0,
				times: undefined,
				// 首页置顶新闻列表
				BannerList: [],
				list: [],
				broadsidelist: [],
				homeCodelist: [],
				homeBannerlist: [],
				bannerArr: []
			}
		},
		components: {
			display,
			news,
			news_release,
			banner,
			profile,
			highlights,
			live,
			forums
		},
		created() {
			this.pageView('ciif_homePage')
			this.pageView('ciif_pageHead')
			this.$store.commit('setExhibitDetail', {})
			this.getMeetingTime()
			// this.getWebHomeExhibit()
			// this.getBroadside()
			this.bannerList()
			if (['en', 'mt1', 'mt2', 'mt3', 'mt4', 'mt5'].includes(this.$route.name) && !this.En) {
				this.changeLang()
			}
		},
		mounted() {
			this.$store.commit('setHeadIndex', 0)
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			itemFn(item, index) {
				const arr = ['ciif_homePage_live', 'ciif_homePage_exhibit', 'ciif_homePage_supplyDemand', 'ciif_homePage_case', 'ciif_homepage_encourage', 'ciif_homePage_list', 'ciif_homePage_information', 'ciif_homePage_forum']
				this.$jsAPI('track', 'ciif_homePage_all', { contentName_var: item.name })
				this.$jsAPI('track', arr[index])
			},
			bannerFn(v) {
				this.$jsAPI('track', 'ciif_homePage_szgbBanner', {
					contentID_var: v.uuid,
					contentName_var: v.name
				})
			},
			bannerList() {
				const params = {
					"pageNum": 1,
					"pageSize": 100
				}
				// protal.bannerList(params).then(res => {
				// 	this.bannerArr = res.data
				// })
			},
			// 官网查询大会倒计时
			getMeetingTime() {
				protal.getMeetingTime().then(r => {
					this.countdownTime = (r.data.endTime - r.data.currTime) <= 0 ? 0 : (r.data.endTime - r.data.currTime)
					this.autoChange()
					// this.setTimeData(r.endTime - new Date().getTime());
					this.payCountdown(this.countdownTime)
				})
			},
			enterList(index) {
				this.currents = index
				clearInterval(this.times)
			},
			leaveList() {
				this.autoChange()
			},
			autoChange() {
				this.times = setInterval(() => {
					if(this.currents < this.homeCodelist.length - 1) {
						this.currents += 1
					} else {
						this.currents = 0
					}
				}, 3000)
			},
			setTimeData(cm) {
				this.day = Math.floor((cm / 1000 / 60 / 60));
				this.day = this.day.toString().length == 1 ? "0" + this.day : this.day;
				this.hour = Math.floor((cm / 1000 / 60 / 60) % 24);
				this.hour =
					this.hour.toString().length == 1 ? "0" + this.hour : this.hour;
				this.minute = Math.floor((cm / 1000 / 60) % 60);
				this.minute =
					this.minute.toString().length == 1 ? "0" + this.minute : this.minute;
				this.seconds = Math.floor((cm / 1000) % 60);
				this.seconds =
					this.seconds.toString().length == 1 ?
					"0" + this.seconds :
					this.seconds;
			},
			// setTimer() {
			// 	let _this = this;
			// 	this.interval = setInterval(function () {
			// 		_this.payCountdown(_this.countdownTime);
			// 		clearInterval(_this.interval);
			// 	}, 1000);
			// },
			payCountdown(cm) {
				let _this = this;
				if(cm >= 0) {
					this.day = Math.floor(cm / (1000 * 60 * 60 * 24));
					this.day = this.day.toString().length == 1 ? "0" + this.day : this.day;
					this.hour = Math.floor((cm % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					this.hour =
						this.hour.toString().length == 1 ? "0" + this.hour : this.hour;
					this.minute = Math.floor((cm % (1000 * 60 * 60)) / (1000 * 60));
					this.minute =
						this.minute.toString().length == 1 ?
						"0" + this.minute :
						this.minute;
					this.seconds = Math.floor((cm % (1000 * 60)) / 1000);
					this.seconds =
						this.seconds.toString().length == 1 ?
						"0" + this.seconds :
						this.seconds;
					let _msThis = this;

					this.arrs[0] = String(this.day).slice(0, 1)
					this.arrs[1] = String(this.day).slice(1, 2)
					this.arrs[2] = String(this.hour).slice(0, 1)
					this.arrs[3] = String(this.hour).slice(1, 2)
					this.arrs[4] = String(this.minute).slice(0, 1)
					this.arrs[5] = String(this.minute).slice(1, 2)
					this.arrs[6] = String(this.seconds).slice(0, 1)
					this.arrs[7] = String(this.seconds).slice(1, 2)
					this.arrs[8] = String(this.day).slice(2, 3)
					this.arrs = this.arrs.filter(x => x).map((item) => {
						return require(`@/assets/images/time${item}.png`)
					})
					this.$forceUpdate()
					setTimeout(function() {
						cm -= 1000;
						_msThis.payCountdown(cm);
					}, 1000);
				}
			},
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop > 100) {
					this.flagtop = true
				} else {
					this.flagtop = false
				}
			},
			beforeDestroy() {
				window.removeEventListener('scroll', this.handleScroll)
			},
			changeLang() {
				let locale = this.$i18n.locale;
				locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
				localStorage.setItem("lang", this.$i18n.locale);
			},
			prev() {
				this.swiper10.slidePrev()
			},
			next() {
				this.swiper10.slideNext()
			},
			toBottom() {
				localStorage.setItem('scrollTops', null)
				location.href = location.origin + this.$route.path + '#home-display'
			}
		}
	}
</script>

<style lang="less">
	@media screen and (min-width: 769px) {
		.home1 {
			background: linear-gradient( to bottom, #F8F8F9 0%, #ECEDF0 100%);
		}

		.home2 {
			background-color: #0B243F;
			background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/home2-bg.png);
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
		}

		.home3 {
			background-color: #F4F4F6;
			background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/home3-bg.png);
			background-size: 100% auto;
			background-position: left top;
			background-repeat: no-repeat;
		}

		.start-time-wrapper {
			position: relative;
			height: 0;

			.start-time {
				position: absolute;
				left: 0;
				top: .28rem;
				font-size: 28px;
				font-family: SourceHanSansCN-Regular, SourceHanSansCN;
				font-weight: 400;
				color: rgba(255, 255, 255, 0.8);
				line-height: 42px;
				display: flex;

				i {
					margin-right: .45rem;
				}
			}
		}
	}
	
	@media screen and (max-width: 768px) {
		.home2 {
			background-color: #0B243F;
			background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/home2-bg.png);
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue